module.exports = __webpack_public_path__ + "static/media/industries-sand-lime-s.1ba84a2d.jpg";